export default __webpack_public_path__ + "static/media/Flag_of_Mexico.3d85d2fd.svg";